/*
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 20th July 2018 1:28:40 pm
 * Last Modified: Friday, 20th July 2018 1:29:41 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
<template>
    <router-view></router-view>
</template>
<script>
export default {
}
</script>



// WEBPACK FOOTER //
// src/pages/dummy-router-view.vue